import { Store } from '../redux/store';
import { axiosPrivate } from './axiosInstances';
import { refreshSession, getAccessToken } from './authSession';

export { axiosPublic, axiosPrivate } from './axiosInstances';
export { default } from './axiosInstances';

axiosPrivate.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

axiosPrivate.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const { refreshToken } = Store.getState().user;
                if (!refreshToken) {
                    throw new Error('No refresh token');
                }

                await refreshSession();
                originalRequest.headers.Authorization = `Bearer ${getAccessToken()}`;
                return axiosPrivate(originalRequest);
            } catch (refreshError) {
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);
